<template>
    <div class="main">
        <!-- 头部 -->
        <navbar-header></navbar-header>

        <!-- 背景层 -->
        <div class="bg_box">
        </div>
        <!-- <title-bar name="党建专题"></title-bar> -->

        <!-- 新闻列表 -->
        <news-list-box></news-list-box>

        

        <!-- 底部 -->
        <nav-footer></nav-footer>

    </div>
</template>

<script>
    import NavbarHeader from "../components/index/NavbarHeader"
    import NewsListBox from "../components/news/NewsListBox"
    import NavFooter from "../components/common/NavFooter"
    import TitleBar from "../components/common/TitleBar"
    export default {
        components: {
            NavbarHeader,
            NewsListBox,
            NavFooter,
            TitleBar,
        }
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
            background: red !important;
        }
</style>

<style lang="scss" scoped>
.main {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 300px;
        z-index: -1;
    }
    .page {
        width: 1200px;
        margin: 20px auto;
        text-align: center;
    }
}

</style>